import { render, staticRenderFns } from "./QuotationListItem.vue?vue&type=template&id=7da895ff&scoped=true&"
import script from "./QuotationListItem.vue?vue&type=script&lang=js&"
export * from "./QuotationListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da895ff",
  null
  
)

export default component.exports